import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface ServicesQuery {
    organization: Organization
}

export const GET_SERVICES = gql`
    query getServices($organization:ID!, $service: ID, $slug: String) {
        organization(id: $organization) {
            id
            services(id: $service, slug: $slug) {
                id
                name
                slug
            }
        }
    }
`;
